import apiClient, { type PagedResponse } from '../client'
import type {
  ShipmentListItemResponse,
  ShipmentDetailResponse,
  ActiveTrackingResponse,
  ShipmentLookupResponse,
} from '../models/response'
import type { ShipmentEventResponse, SnapRouteResult } from '../models/response/shipment'
import type { LiveCarbonFootprint } from '../models/response/sustainability'

const BASE_PATH = '/shipments'

export const shipmentsService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
    shipmentState?: number
  }): Promise<PagedResponse<ShipmentListItemResponse>> {
    return apiClient.get<PagedResponse<ShipmentListItemResponse>>(BASE_PATH, params)
  },

  async getById(id: string): Promise<ShipmentDetailResponse> {
    return apiClient.get<ShipmentDetailResponse>(`${BASE_PATH}/${id}`)
  },

  async getEvents(id: string): Promise<ShipmentEventResponse[]> {
    return apiClient.get<ShipmentEventResponse[]>(`${BASE_PATH}/${id}/events`)
  },

  async getActiveTracking(): Promise<ActiveTrackingResponse> {
    return apiClient.get<ActiveTrackingResponse>(`${BASE_PATH}/active-tracking`)
  },

  getPhotoUrl(shipmentId: string, photoId: string): string {
    return apiClient.buildUrl(`${BASE_PATH}/${shipmentId}/photos/${photoId}/file`)
  },

  async getByBatchCode(batchCode: string): Promise<ShipmentLookupResponse> {
    return apiClient.get<ShipmentLookupResponse>(`${BASE_PATH}/by-batch-code/${batchCode}`)
  },

  async forceSetState(id: string, shipmentState: number): Promise<boolean> {
    return apiClient.post<boolean>(`${BASE_PATH}/${id}/force-state`, { shipmentState })
  },

  // "Afinar ruta": pega la traza GPS a la red vial (Snap to Roads) on-demand para un
  // traslado terminado sin ruta ajustada. Idempotente. Devuelve la polilínea vigente.
  async snapRoute(id: string): Promise<SnapRouteResult> {
    return apiClient.post<SnapRouteResult>(`${BASE_PATH}/${id}/snap-route`, {})
  },

  // Huella de carbono en vivo (parcial desde GPS acumulados; definitiva si ya hubo peso neto).
  async carbonLive(id: string): Promise<LiveCarbonFootprint> {
    return apiClient.get<LiveCarbonFootprint>(`${BASE_PATH}/${id}/carbon-live`)
  },
}
